import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MaterialIcon from 'material-icons-react';
import { colors, media } from '@material-dev/thread';
import { Flex } from '@rebass/grid';

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: ${colors.black10};
  color: #fff;
  min-height: 80px;
  width: 100%;
  border-radius: 4px;
  cursor: pointer;
  padding: 16px;
  margin-bottom: 16px;

  &:hover {
    background-color: ${colors.black20};
  }

  &:active {
    background-color: ${colors.black38};
  }

  * {
    /* prevent incorrect gtm triggering on button children */
    pointer-events: none;
  }

  ${media.sm`
    width: 50%;
    margin-bottom: 0;

    &:first-child {
      margin-right: 8px;
    }
  
    &:last-child {
      margin-left: 8px;
    }
  `}
`;

const Heading = styled.p`
  margin: 0;
  margin-bottom: 6px;
  padding: 0;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #fff;
`;

const Subhead = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  color: ${colors.white70};
  text-transform: none;
`;

const SvgIconContainer = styled(Flex).attrs({
  justifyContent: 'center',
  alignItems: 'center'
})`
  background-color: ${colors.white};
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-left: 16px;
`;

const OtherThingsButton = (props) => {
  return (
    <StyledButton onClick={props.onClick} id={`admin_${props.name}`}>
      <Flex flexDirection="column" justifyContent="center" alignItems="start" flex="1">
        <Heading>{props.heading}</Heading>
        <Subhead>{props.subhead}</Subhead>
      </Flex>

      {props.icon && <MaterialIcon icon={props.icon} size={48} color={colors.white30} />}
      {
        props.svgIcon &&
          <SvgIconContainer>
            <img src={props.svgIcon} width="24"/>
          </SvgIconContainer>
      }
    </StyledButton>
  );
};

OtherThingsButton.propTypes = {
  icon: PropTypes.string,
  svgIcon: PropTypes.string,
  heading: PropTypes.string.isRequired,
  subhead: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string
};

OtherThingsButton.defaultProps = {
  icon: null,
  svgIcon: null,
  heading: '',
  subhead: '',
  onClick: () => {},
  name: ''
};

export default OtherThingsButton;


// WEBPACK FOOTER //
// ./src/app/admin/components/EmptyListPage2/OtherThingsButton/index.js